var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWind(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 76,
    viewBox: "0 0 75 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.5115 14.7373C50.9055 14.7373 48.3512 15.6478 46.3192 17.3009C45.6253 17.8656 45.5144 18.8931 46.0714 19.5963C46.6286 20.2994 47.6428 20.412 48.3367 19.8474C49.7987 18.6579 51.6365 18.0029 53.5115 18.0029C58.0694 18.0029 61.7775 21.7605 61.7775 26.3791C61.7775 30.9978 58.0693 34.7554 53.5115 34.7554H23.2129C22.323 34.7554 21.6016 35.4864 21.6016 36.3882C21.6016 37.2899 22.323 38.021 23.2129 38.021H53.5115C59.8463 38.021 65.0001 32.7985 65.0001 26.3791C65.0001 19.9598 59.8462 14.7373 53.5115 14.7373Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M20.126 31.501H37.3389C38.2289 31.501 38.9503 30.7699 38.9503 29.8682C38.9503 28.9664 38.2289 28.2354 37.3389 28.2354H20.126C19.2361 28.2354 18.5146 28.9664 18.5146 29.8682C18.5146 30.7699 19.2361 31.501 20.126 31.501Z",
    fill: "#EDEEF1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8872 41.2979H11.6113C10.7214 41.2979 10 42.0289 10 42.9307C10 43.8324 10.7214 44.5635 11.6113 44.5635H36.8872C40.5422 44.5635 43.5158 47.5767 43.5158 51.2804C43.5158 54.9842 40.5422 57.9974 36.8872 57.9974C35.3836 57.9974 33.91 57.4721 32.7374 56.5183C32.0436 55.9538 31.0294 56.0661 30.4722 56.7693C29.915 57.4725 30.026 58.5002 30.72 59.0647C32.4625 60.4822 34.6527 61.2629 36.8872 61.2629C42.3192 61.2629 46.7385 56.7847 46.7385 51.2803C46.7385 45.7759 42.3192 41.2979 36.8872 41.2979Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6113 31.501H13.785C14.6749 31.501 15.3963 30.7699 15.3963 29.8682C15.3963 28.9664 14.6749 28.2354 13.785 28.2354H11.6113C10.7214 28.2354 10 28.9664 10 29.8682C10 30.7699 10.7214 31.501 11.6113 31.501Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M31.0547 49.4297C31.0547 48.5279 30.3332 47.7969 29.4434 47.7969H19.7754C18.8855 47.7969 18.1641 48.5279 18.1641 49.4297C18.1641 50.3314 18.8855 51.0625 19.7754 51.0625H29.4434C30.3333 51.0625 31.0547 50.3314 31.0547 49.4297Z",
    fill: "#EDEEF1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWind);
export default __webpack_public_path__ + "static/media/wind.be0455e586b21e017cddb934d927fe02.svg";
export { ForwardRef as ReactComponent };